import {inject, injectable} from "inversify";
import {KODivision, Matchday} from "@/modules/competitions/entity";
import {Season} from "@/modules/season/entity";
import {CupCompetition} from "@/modules/competitions/entity/CupCompetition";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export default class CupCompetitionMatchdayGenerator {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {}

  async generate(season: Season, competition: CupCompetition) {
    console.debug(`generated matchdays for competition: ${competition.name}.`);
    competition = await CupCompetition
      .createQueryBuilder('competition')
      .leftJoinAndSelect('competition.divisions', 'division')
      .where('competition.id = :competitionId', {competitionId: competition.id})
      .getOneOrFail();

    let division: KODivision | undefined = competition.divisions.find(d => !d.prev);

    const seasonStartDate = season.startDate.clone();

    const data = this.configRepository.get('competitions.schedules')
      .find((item) => competition instanceof item.competition);

    if (!data) {
      throw 'No schedule data found.';
    }

    while (division) {
      let scheduledAt = season.startDate.clone();

      const currentScheduleRound = competition.rounds - division.round!;
      const slots = data.schedule[currentScheduleRound];

      scheduledAt = seasonStartDate.add(Math.floor(slots[0] / 2), 'week').subtract(2, 'days');
      if (slots[0] % 2 === 1) {
        scheduledAt = scheduledAt.add(3, 'days');
      }

      const homeMatchday = new Matchday();
      homeMatchday.season = season;
      homeMatchday.scheduledAt = scheduledAt.toDate();

      homeMatchday.name = translator.t('first_leg');
      homeMatchday.division = division;
      await homeMatchday.save();
      console.debug('generated matchday: ' + homeMatchday.name);

      if (competition.homeAndAway && (competition.homeAndAwayFinal || division.round! > 1)) {
        scheduledAt = seasonStartDate.add(Math.floor(slots[1] / 2), 'week').subtract(2, 'days');
        if (slots[1] % 2 === 1) {
          scheduledAt = scheduledAt.add(3, 'days');
        }

        const awayMatchday = new Matchday();
        awayMatchday.season = season;
        awayMatchday.scheduledAt = scheduledAt.toDate();
        awayMatchday.name = translator.t('second_leg');
        awayMatchday.prev = homeMatchday;
        awayMatchday.division = division;
        await awayMatchday.save();

        homeMatchday.next = awayMatchday;
        await homeMatchday.save();
        console.debug('generated matchday: ' + awayMatchday.name);
      }

      await division.load('next');
      division = division.next;
    }
  }
}
